<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { merchantComputed, authComputed } from '@state/helpers'
import cloneDeep from 'lodash/cloneDeep'
const initDefaultValue = {
  description: null,
  images: [],
  isEnabled: 1,
  prepaidGroupAliases: [],
  productIds: [],
  serviceIds: [],
  terms: '',
  title: '線上儲值',
}
export default {
  name: 'deposit',
  page: {
    title: '儲值點數',
    meta: [{ name: 'description', content: 'Prepaid List' }],
  },
  components: {
    Layout,
    BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    products: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    goods: {
      type: Array,
      required: true,
    },
    prepaids: {
      type: Array,
      required: true,
    },
    // serviceCategory: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze([
        {
          title: '基本設定',
          component: () => lazyLoadComponent(import('./components/BasicSetting')),
        },
        {
          title: '方案設定',
          component: () => lazyLoadComponent(import('./list')),
        },

        {
          title: '限制設定',
          component: () => lazyLoadComponent(import('./components/LimitSetting')),
        },
        {
          title: '適用範圍',
          component: () => lazyLoadComponent(import('./components/AvaliableSetting')),
        },
      ]),

      mode: '',
      defaultValue: cloneDeep(initDefaultValue),
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
  },
  watch: {
    // 'currentMerchant': {
    //   immediate: true,
    //   handler (val, oldVal) {
    //     console.log('aaa')
    //     this.setDefaultValue()
    //   },
    //   deep: true
    // },
  },
  created() {},
  async mounted() {
    this.$nextTick(async () => {
      await this.getDeposit()
    })
    // await this.getDeposit()
    // setTimeout(() => {
    //   this.setDefaultValue()
    // },800)
  },
  methods: {
    async updateMerchantCached() {
      await this.$store.dispatch('merchant/fetchSingle')
    },
    /**
     * @description 基本設定 -> 取得
     */
    async getDeposit() {
      const { response } = await this.$store.dispatch('merchant/getCosmeticBasicSet', {
        type: 'deposit',
      })
      Object.keys(response.items).forEach((key) => {
        this.$set(this.defaultValue, key, response.items[key])
      })
    },
    /**
     * @description 基本設定 -> 儲存
     */
    // async tryToStore() {
    //   const { response } = await this.$store.dispatch(
    //     'merchant/postCosmeticBasicSet',
    //     {
    //       "type": "prepaid",
    //       "payload": this.submitData
    //     }
    //   )
    //   if(response.code === 200){
    //     this.$message({
    //       message: '儲存成功！',
    //       type: 'success',
    //     })
    //   }
    // },
    // setDefaultValue(){
    //   if(this.currentMerchant.merchantConfig.depositSetting)
    //   this.defaultValue = this.currentMerchant.merchantConfig.depositSetting ? cloneDeep(this.currentMerchant.merchantConfig.depositSetting) : {}
    // }
  },
}
</script>

<template>
  <Layout>
    <el-tabs v-if="currentMerchant" v-model="activeTab" :class="{ isEdit: mode !== '' }" type="border-card" stretch class="isStyleBase">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"> </el-tab-pane>
    </el-tabs>
    <component :is="tabList[activeTab].component" :class="$style.page" :products="products" :prices="prices" :goods="goods" :prepaids="prepaids" :default-value="defaultValue" @update="getDeposit"> </component>
  </Layout>
</template>

<style lang="scss" module>
.table {
  @include layer-elevation(5);
}
:global {
  .isEdit {
    .el-tabs__header {
      display: none;
    }
    &.el-tabs--border-card {
      border-radius: 0;
      background: none;
      box-shadow: none;

      .el-tabs__content {
        padding: 0;
      }
    }
  }
}
</style>
